(function(){
    'use strict';

    angular.module('elogbooks.user.contact-us', []);
})();
